import defaultClient from '@/plugins/axios/defaultClient'

export default {
  getMe() {
    return defaultClient.get('/users/me')
  },
  incorrectInformation(uuid) {
    return defaultClient.post(`/users/${uuid}/incorrect-information`)
  },
}
